<template>
  <ngc-accordion-group multiple>
    <ngc-accordion
      v-for="(permissionGroup, groupIndex) in permissionGroups"
      :key="groupIndex + '-group'"
      :title="permissionGroup.name"
      :is-expanded.prop="isGroupExpanded(groupIndex)"
      style="--ngc-accordion-width: 100%"
      @toggle-expand="toggleGroup(groupIndex)"
    >
      <div
        slot="content"
        class="permission-group__content"
      >
        <div
          v-if="permissionGroup.showLabelTooltip"
          class="permission-group__note gator-body-3 mb-3"
        >
          {{ permissionGroup.labelTooltipText }}
        </div>
        <permission-row
          v-for="(setting, rowIndex) in permissionGroup.settings"
          :key="groupIndex + '-' + rowIndex + '-row'"
          :permission="setting"
          :non-default-permissions="nonDefaultPermissions"
          :view-only="viewOnly"
          class="permission-row item-border-bottom"
          @permissionChange="handleChange($event)"
        />
      </div>
    </ngc-accordion>
  </ngc-accordion-group>
</template>

<script>
import PermissionRow from './permissionRow'

export default {
  name: 'PermissionGroups',
  components: {
    PermissionRow
  },
  props: {
    permissionGroups: {
      type: Array,
      required: true
    },
    nonDefaultPermissions: {
      type: Array,
      required: false,
      default: () => []
    },
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      expandedGroups: {}
    }
  },
  watch: {
    expanded (val) {
      this.expandAll(val)
    }
  },
  created () {
    this.expandAll(this.expanded)
  },
  methods: {
    isGroupExpanded (index) {
      return !!this.expandedGroups[index]
    },
    toggleGroup (index) {
      this.$set(this.expandedGroups, index, !this.expandedGroups[index])
    },
    expandAll (expanded) {
      const state = {}
      if (expanded) {
        this.permissionGroups.forEach((_group, index) => {
          state[index] = true
        })
      }
      this.expandedGroups = state
    },
    handleChange (changedPermissions) {
      this.$emit('permissionChange', changedPermissions)
    }
  }
}
</script>

<style lang="scss" scoped>

.permission-row {
  margin: 0;
}

.permission-group__note {
  color: var(--color-text-secondary, #6D6D6D);
}

// Cancel the accordion's default 16px top content padding so the first row sits
// snug under the header — the rows supply their own vertical spacing.
.permission-group__content {
  margin-top: -16px;
}

</style>
